module.exports = __webpack_public_path__ + "img/screenr-thumb.4789e32f.png";